import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'
import React from 'react'

import { defaultToEmptyString } from '../../../assets/ts/formatting/formatting'

const InquiryDueoutDetails = ({ description, inquiryDueoutDetails }) => {
  return (
    <>
      <div className='d-flex align-items-center flex-wrap py-2 w-100'>
        {inquiryDueoutDetails.map((item) => (
          <div
            aria-label={`${item.title} ${item.subtitle}`}
            className='sourcesanspro mb-2 col-lg-3 col-md-6 col-sm-12 font-12 text-break'
            key={item.title}
            tabIndex={0}
          >
            <p className='title-color'>{DOMPurify.sanitize(defaultToEmptyString(item.title))}</p>
            <p className='title-color24'>
              {DOMPurify.sanitize(defaultToEmptyString(item.subtitle))}
            </p>
          </div>
        ))}
      </div>
      <div className='mt-2 font-13 sourcesanspro title-color'>
        <div aria-label='Description' className='subtitle-color2 pb-1' tabIndex={0}>
          Description
        </div>
        <div aria-describedby='details-ddescription' id='details-ddescription' tabIndex={0}>
          <p className='pb-2 1h-normal'>
            <p
              className='m-0 p-0'
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(defaultToEmptyString(description)),
              }}
            ></p>
          </p>
        </div>
      </div>
    </>
  )
}
InquiryDueoutDetails.propTypes = {
  description: PropTypes.any,
  inquiryDueoutDetails: PropTypes.array,
}
export default InquiryDueoutDetails
